import React, { FC, useContext } from 'react';
import get from 'lodash/get';

import InputField from 'src/presentation/components/forms/InputField';
import FormContext from 'src/presentation/contexts/FormContext';
import NodeSelector from 'src/presentation/components/pages/ivr/components/NodeSelector';
import { AddTemporarySplit } from './AddTemporarySplit';
import { Content, Footer, Row, ScrollRow } from 'src/presentation/components/pages/ivr/layouts/IvrLayout';
import {
  NodeProps,
  SIDE_PANEL_ROW_TYPES,
  DESCRIPTION_PLACEHOLDER_TEXT,
  DESCRIPTION_LABEL_TEXT,
} from 'src/presentation/components/pages/ivr/constants/ivrConstants';

const TemporarySplitNode: FC<NodeProps> = ({
  attr,
  disabled,
  nodeList,
  onSelectNode,
  readOnly,
  selectedOptionIndex,
}) => {
  const { workingState } = useContext(FormContext);
  const currentNodeId = get(workingState, `${attr}.id`);

  return (
    <>
      <Content>
        <Row>
          <InputField
            attr={`${attr}.name`}
            data-aid="name"
            description="The name you can refer to link to other nodes"
            disabled={disabled}
            label="Name"
            readOnly={readOnly}
          />
        </Row>

        <Row>
          <InputField
            attr={`${attr}.description`}
            data-aid="description"
            disabled={disabled}
            label={DESCRIPTION_LABEL_TEXT}
            placeholder={DESCRIPTION_PLACEHOLDER_TEXT}
            readOnly={readOnly}
          />
        </Row>

        <AddTemporarySplit
          attr={attr}
          data-aid="nodeSchedules[0]"
          disabled={disabled}
          nodeList={nodeList}
          readOnly={readOnly}
          onSelectNode={onSelectNode}
        />
      </Content>
      <Footer>
        <ScrollRow scrollToIndex={selectedOptionIndex} type={SIDE_PANEL_ROW_TYPES.NOT_MATCH_ROW}>
          <NodeSelector
            searchable
            attr={`${attr}.defaultNextId`}
            data-aid="defaultNextId"
            disabled={disabled}
            label="Default Next Node"
            description="The next IVR node if none of the schedules match the current time"
            omittedNodeIds={[currentNodeId]}
            onSelectNode={onSelectNode}
            options={nodeList}
            readOnly={readOnly}
          />
        </ScrollRow>
      </Footer>
    </>
  );
};

export default TemporarySplitNode;
